import { CLASSES_CORE, MODIFIERS, VERSION, EVENTS } from './constants';
import DpitCore from './DpitCore';
import {
	getCssValFloat, getReverseBasePos, hasCssProperty, isElementScrollableX,
} from '../../modules/dpitUtilsPublic';
import DpitBB from './DpitBB';
import {
	hideElement,
	showElement
} from '../../../../../includes/assets/js/modules/dpitHidden';


export default class DpitCoreSticky extends DpitCore {
	constructor(wrapEl, mainCfg, tourCfg) {
		super(wrapEl, mainCfg, tourCfg);
		hideElement(this.arrowEl);
		document.documentElement.classList.add(CLASSES_CORE.isStickyTheme);
	}

	printDebugMessage() {
		console.log('[dpit] INIT DpitCoreSticky: v' + VERSION + ' | Sticky engine loaded');
	}

	fireAfterStepChangeEvent(backward) {
		const isStickyTheme = this.isStickyTheme();
		const isOnTop = isStickyTheme ? this.isStickyThemeOnTop() : false;
		this.doAction(EVENTS.afterStepChange, {
			isStickyTheme: isStickyTheme,
			isStickyThemeOnTop: isOnTop && isStickyTheme,
			backward: backward,
			currentStepObj: this.stepObject4Hooks(this.stepItem)
		});
	}

	filterWinBoardMargin(margin) {
		const stickyTooltipOffset = this.getWinBoardOffset();
		margin.top += stickyTooltipOffset.top;
		margin.bottom += stickyTooltipOffset.bottom;
		return margin;
	}

	determineTooltipPosition() {

		const maxBoardBB = this.isFixedPos ? this.winBB : this.docBB;
		const tooltipDist = {
			top: (this.targetBB.top) - (maxBoardBB.top + this.tooltipBB.height),
			bottom: (maxBoardBB.bottom - this.tooltipBB.height) - (this.targetBB.top + this.targetBB.height)
		};

		let basePos = tooltipDist.bottom > tooltipDist.top || this.isDummyMode() ? 'bottom' : 'top';
		if (tooltipDist.bottom > 0 && tooltipDist.top > 0) {
			basePos = 'bottom';
			// if both are possible choose last
			//basePos = this.tooltipPos.base;
		}

		return {
			base: basePos
		};
	}

	placeTooltipInSoftRefresh() {
		this.placeTooltip(false, true);
	}


	fixPositionOutOfTheWindowForNotFixedElements() {
		this.tooltipTextEl.style.maxHeight = '';
		return false;
	}

	fixPositionOutOfTheBoard() {
		this.tooltipTextEl.style.maxHeight = '';
		this.actualizeTooltipBB();
		if (this.isDummyMode()) {
			const diff = this.tooltipBB.height - this.winBB.height;
			if (diff > 0) {
				//this.tooltipEl.style.maxHeight = this.winBB.height + 'px';
				let tooltipTextHeight = $(this.tooltipTextEl).height();
				this.tooltipTextEl.style.maxHeight = (tooltipTextHeight - diff) + 'px';
				//$(this.tooltipTextEl).height(tooltipTextHeight - diff);
				this.actualizeTooltipBB();
				this.actualizeFlier(true);
			}
		}

		return false;
	}


	/*fixOverWinBoardTopForFixedElements(containerBB) {
		//(this.targetBB.top - tooltipSizesArrowInc.height) - containerBB.top
		//console.log('fix over TOP (tooltip on TOP)');
		const topBkp = $(this.tooltipEl).offset().top;
		let tooltipTextHeight = $(this.tooltipTextEl).height();
		//const textLayerMaxHeight = Math.floor(Math.max(tooltipTextHeight - (containerBB.top + 1 - this.tooltipBB.top)));
		const textLayerMaxHeight = Math.floor(Math.max(tooltipTextHeight - (containerBB.top + 1 - this.tooltipBB.top), SIZE_LIMITS_PX.minTooltipContentHeightFixedPos));
		this.tooltipTextEl.style.height = textLayerMaxHeight + 'px';

		$(this.tooltipEl).offset({ top: $(this.tooltipEl).offset().top + tooltipTextHeight - textLayerMaxHeight });
		this.actualizeTooltipBB();
		let isOverTop = this.tooltipBB.top < containerBB.top;
		if (isOverTop) {
			/*$(this.tooltipEl).offset({ top: topBkp });
			this.tooltipTextEl.style.height = '';
			this.actualizeTooltipBB();
			isOverTop = this.tooltipBB.top < containerBB.top;*/
	/*}
		return isOverTop;
	}*/

	placeTooltipCore(_, useLastPosition) {
		if (!(useLastPosition && this.tooltipPos)) {
			this.tooltipPos = this.determineTooltipPosition(this.stepItem);
		}
		this.tooltipEl.classList.add(`${CLASSES_CORE.tooltip}--${this.tooltipPos?.base}`);
		this.fixPositionOutOfTheWindow();
		this.actualizeBoardSizes();
		if (this.debugVisualizer) this.debugVisualizer.visualizeBoards(this.docBoardBB, this.winBoardBB, this.docBB, this.winBB);
		return {
			desiredNumberPos: {
				x: 'right',
				y: getReverseBasePos(this.tooltipPos.base),
				onTooltip: false
			},
			isNeededNextIteration: false
		};
	}

	getNumberIntersectionFeature(possiblePositionsLT, posX, posY, bbContainerToTest) {
		if (bbContainerToTest === this.tooltipBB) return 0;
		else return super.getNumberIntersectionFeature(possiblePositionsLT, posX, posY, bbContainerToTest);
	}

	getNumberDestElSizeFeature(numberLayerHalfSize, bbContainerToTest) {
		if (bbContainerToTest === this.tooltipBB) return { x: 0, y: 0 };
		else return super.getNumberDestElSizeFeature(numberLayerHalfSize, bbContainerToTest);
	}

	getPlaceNumberRepetitionParams(oldDesiredPosition) {

		return {
			enableIndentation: true,
			desiredPosition: { ...oldDesiredPosition, onTooltip: false },
			maxIterations: 1
		};
	}

	isNumberCloseToTooltip() {
		return false;
	}


	getIsPossibleNumberPositionsInBoardObject(possiblePositionsLT) {
		const maxAreaBB = this.isFixedPos ? this.winBB : this.docBB;
		return {
			left: possiblePositionsLT.left >= maxAreaBB.left && possiblePositionsLT.left + this.numberBB.width <= maxAreaBB.right,
			top: possiblePositionsLT.top >= maxAreaBB.top && possiblePositionsLT.top + this.numberBB.height <= maxAreaBB.bottom,
			right: possiblePositionsLT.right >= maxAreaBB.left && possiblePositionsLT.right + this.numberBB.width <= maxAreaBB.right,
			bottom: possiblePositionsLT.bottom >= maxAreaBB.top && possiblePositionsLT.bottom + this.numberBB.height <= maxAreaBB.bottom,
		};
	}

	getScrollFlierOptions(scrollTimeMs = 500) {

		const res = {
			align: {
				top: 0,
				left: 0.5,
				lockX: !isElementScrollableX(document.documentElement)
			},
			time: scrollTimeMs
		};
		if (this.flierBB) {
			if (this.flierBB.height > this.winBoardBB.height) {
				switch (this.tooltipPos.base) {
					case 'top':
					case 'bottom':
						res.align.topOffset = this.winBoardBB.top;
						break;
				}
			}
			else {
				res.align.topOffset = this.winBoardBB.top + (this.winBoardBB.height - this.flierBB.height) / 2;
			}
		}
		return res;
	}

	getWinBoardOffset() {
		if (this.tooltipEl) {
			const areBulletsFixed = this.bulletsLayer && hasCssProperty(getComputedStyle(this.bulletsLayer), 'position', ['fixed']);
			let bulletsHeight = areBulletsFixed ? this.bulletsLayer.getBoundingClientRect().height : 0;
			if (this.tooltipPos?.base === 'top') {
				const bulletsBottom = getCssValFloat(this.bulletsLayer, 'bottom', 0);
				return {
					top: this.tooltipBB.height,
					bottom: bulletsBottom + bulletsHeight
				};
			}
			else {
				const bulletsTop = areBulletsFixed ? getCssValFloat(this.bulletsLayer, 'top', 0) : 0;
				return {
					top: bulletsTop + bulletsHeight,
					bottom: this.tooltipEl.getBoundingClientRect().height
				};
			}
		}
		return { top: 0, bottom: 0 };
	}

	isProgressBarEnabled() {
		return this.stepItems.length > 1;
	}

	isStickyThemeOnTop() {
		return this.isStickyTheme() && this.tooltipPos?.base === 'top';
	}


	getFlierBB(targetBB, numberBB) {
		return DpitBB.intersect(DpitBB.merge(targetBB, numberBB), this.docBB);
	}

	actualizeTooltipMinWidth() {
		if (this.winBB.width > 800) {// in css atS
			this.actualizeStickyTooltipHeight();
		}
		else {
			this.actualizeStickyTooltipHeight();
			super.actualizeTooltipMinWidth();
		}
	}

	actualizeTheme(theme, accentColor = null) {
		super.actualizeTheme(theme, accentColor);
		this.actualizeProgressBar();
	}

	actualizeTooltipMaxWidth() {
		this.tooltipEl.style.maxWidth = '';
	}


	actualizeStickyTooltipHeight() {
		if (this.tooltipEl) {
			this.buttonPrevNextWrapEl.classList.remove(
				CLASSES_CORE.buttonPrevNextWrap + MODIFIERS.vert
			);
			this.actualizeButtonsTextVisibility(false);
			const buttonsPrevNextWrapHeight = this.buttonPrevNextWrapEl.getBoundingClientRect().height;
			let tooltipElHeight = this.tooltipEl.offsetHeight;
			if (tooltipElHeight > 4 * buttonsPrevNextWrapHeight) {
				this.buttonPrevNextWrapEl.classList.add(CLASSES_CORE.buttonPrevNextWrap + MODIFIERS.vert);
				//if (this.options.labeling.button_arrows === 'vector' || this.options.labeling.button_arrows === 'text') {
				tooltipElHeight = $(this.tooltipEl).height();
				if (tooltipElHeight > 0.5 * this.winBB.height) {
					this.actualizeButtonsTextVisibility(true);
				}
				//}
			}
		}
	}

	loadCancelButtonIcons() {
		super.loadCancelButtonIcons('vector');
	}

	/*actualizeStepNumber() {
		if (!this.stepItem || this.isDummyMode()) {
			hideElement(this.numberEl, false);
		} else {
			this.actualizeStepNumberEl(this.numberEl);
		}
		this.actualizeStepNumberEl(this.numberElSec);
	}*/

	/*createLayers() {
		//super.createLayers();
		//hideElement(this.numberEl, false);
		//this.numberElSec = this.createNumberLayer(MODIFIERS.sec);
		//this.tooltipEl.prepend(this.numberElSec);
	}*/

	unplugTheme() {
		//this.numberElSec?.remove();
		showElement(this.arrowEl);
		document.documentElement.classList.remove(CLASSES_CORE.isStickyTheme);
	}

}